<template>
  <section class="section pb-0 pt-0 section-components">
    <div class="py-5 bg-dark">
      <div class="container-fluid pr-6 pl-6">
        <!-- Inputs (alternative) -->
        <h2 class="mb-3">
          <small class="h2">Explore Hostels</small>
        </h2>
        <div class="row">
          <div class="col-3" v-for="hostel in hostels" v-bind:key="hostel.num">
            <!-- <div class="card" style="width: 18rem;">
              <img
                :src="'https://picsum.photos/100/?random='+hostel.num"
                class="card-img-top"
                alt="..."
              />
              <div class="card-body">
                <p
                  class="card-text"
                >Some quick example text to build on the card title and make up the bulk of the card's content.</p>
              </div>
            </div>-->
            <div class="card bg-dark text-white">
              <img :src="hostel.image" class="card-img" />
              <div class="card-img-overlay" style="top:75%">
                <h3 class="card-title text-white font-weight-bold">{{hostel.name}}</h3>
              </div>
            </div>
            <!-- <b-card no-body class="overflow-hidden">
              <b-row no-gutters>
                <b-col>
                  <b-card-img
                    :src="'https://picsum.photos/200/?random='+hostel.num"
                    class="img-fluid border-0 rounded"
                  ></b-card-img>
                </b-col>
                <b-col md="6">
                                <b-card-body :title="hostel.name">
                                </b-card-body>
                </b-col>
              </b-row>
            </b-card>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      hostels: [
        { num: 1, name: "Oye Inn Hostel", image: '/img/hostels/oye-inn.jpg' },
        { num: 2, name: "Executive Hostel", image: '/img/hostels/the-executive.jpg' },
        { num: 3, name: "Nest Hostel", image: '/img/hostels/nest.jpg' },
        { num: 4, name: "Ayensu Plaza", image: '/img/hostels/ayensu-plaza.jpg' }
      ]
    };
  }
};
</script>
<style>
</style>
